"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Textfield = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormFieldWrapper = _interopRequireDefault(require("../FormFieldWrapper/FormFieldWrapper"));

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _useActiveClassName2 = require("../../customHooks/useActiveClassName");

var _textfieldConfig = require("./textfieldConfig");

var _types = require("../../types");

var _validation = require("../../types/validation");

var _requiredIndicator = require("../../utils/requiredIndicator");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var FieldType = _flowRuntime["default"].tdz(function () {
  return _types.FieldType;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var TextfieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _textfieldConfig.TextfieldElementDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true), _flowRuntime["default"].property("onBlur", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())), true), _flowRuntime["default"].property("noOptionalLabel", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("textfield", _flowRuntime["default"].ref(TextfieldElementDefinition))));

var TextfieldProps = _flowRuntime["default"].type("TextfieldProps", _flowRuntime["default"].object(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("input", _flowRuntime["default"].object()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("textfield", _flowRuntime["default"].ref(TextfieldElementDefinition)), _flowRuntime["default"].property("meta", _flowRuntime["default"].object())));

var getInputType = function getInputType(type) {
  if (type === 'currency') {
    return 'number';
  }

  return type;
};

var getInputStep = function getInputStep(type) {
  if (type === 'currency') {
    return 0.01;
  }

  return undefined;
};

var Textfield = function Textfield(_arg) {
  var disabled = _arg.disabled,
      input = _arg.input,
      inputStyle = _arg.inputStyle,
      isRequired = _arg.isRequired,
      textfield = _arg.textfield,
      meta = _arg.meta;

  var _useActiveClassName = (0, _useActiveClassName2.useActiveClassName)(input),
      isActive = _useActiveClassName.isActive,
      activeClassName = _useActiveClassName.activeClassName;

  var className = "".concat(inputStyle.inputClass, " ").concat(activeClassName('input'));

  var getValidationClass = function getValidationClass() {
    var inputClass = inputStyle.inputClass;

    if (inputClass && inputClass.includes('error')) {
      return 'error';
    }

    if (inputClass && inputClass.includes('success')) {
      return 'success';
    }

    return '';
  };

  var labelClassName = "".concat(activeClassName('label'), " ").concat(getValidationClass());
  var showPlaceholder = !!(meta && !meta.active && !isActive && textfield.label);
  var placeholder = showPlaceholder && textfield.label;
  var requiredString = showPlaceholder ? (0, _requiredIndicator.requiredIndicator)(isRequired) : '';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: textfield.hideLabel ? '' : 'float-label'
  }, /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    autoComplete: textfield.autoComplete,
    className: className,
    disabled: disabled,
    id: input.name,
    maxLength: textfield.maxLength,
    placeholder: "".concat(placeholder || '').concat(requiredString),
    step: getInputStep(textfield.type),
    type: getInputType(textfield.type)
  }, input)), (meta && meta.active || isActive) &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  _react["default"].createElement("label", {
    className: labelClassName,
    htmlFor: input.name
  }, /*#__PURE__*/_react["default"].createElement(_FieldLabel["default"], {
    field: textfield,
    isRequired: isRequired
  })));
};

exports.Textfield = Textfield;
Textfield.defaultProps = {
  disabled: false
};

var RFTextfield = function RFTextfield(_arg2) {
  var disabled = _arg2.disabled,
      inheritedFieldValidation = _arg2.inheritedFieldValidation,
      onBlur = _arg2.onBlur,
      textfield = _arg2.textfield,
      noOptionalLabel = _arg2.noOptionalLabel;
  return /*#__PURE__*/_react["default"].createElement(_FormFieldWrapper["default"], {
    field: textfield,
    renderField: function renderField(_ref) {
      var input = _ref.input,
          inputStyle = _ref.inputStyle,
          isRequired = _ref.isRequired,
          meta = _ref.meta;
      return /*#__PURE__*/_react["default"].createElement(Textfield, {
        disabled: disabled,
        input: input,
        inputStyle: inputStyle,
        isRequired: noOptionalLabel ? true : isRequired,
        textfield: textfield,
        meta: meta
      });
    },
    inheritedFieldValidation: inheritedFieldValidation,
    onBlur: onBlur
  });
};

RFTextfield.defaultProps = {
  disabled: false,
  inheritedFieldValidation: [],
  onBlur: undefined,
  noOptionalLabel: false
};
var _default = RFTextfield;
exports["default"] = _default;